import { Provider } from 'cerebral'
import { init, translate } from '@billes/translator-client'

export default () => {
  return Provider({
    bootstrap: init,
    t: translate
  })
}



// WEBPACK FOOTER //
// ./src/providers/TranslationProvider.js